import { render, staticRenderFns } from "./ModalAddAttribute.vue?vue&type=template&id=0010570e"
import script from "./ModalAddAttribute.vue?vue&type=script&lang=js"
export * from "./ModalAddAttribute.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports